import { renderErrorMessageLineLayoutTemplate } from '@next-adapter/templates/renderers/generators/form-pipeline/form-component-shared/error-message-line.js'
export function errorMessageLine(pathExpression: string, indent: string): string {
  return renderErrorMessageLineLayoutTemplate({
    indent: indent,
    pathExpression: pathExpression
  })
}
